import { IToolDefinition } from "../../types/journeyInput.types";

// Tools are reusable across journeys. Qualification and visibility rules live on the journey; tools are kept agnostic.
export const toolDefinitions: Record<string, IToolDefinition> = {
  "annuity-quotes-quick": {
    toolId: "annuity-quotes-quick",
    icon: "list-task",
    name: "Annuity Calculator",
    heading: "Get initial annuity estimates.",
    description: "Get initial annuity estimates.",
    route: "/landers/annuitycalculator",
    completedWhen: {
      any: [
        {
          fact: "milestoneCompleted",
          params: { id: "100228" }, // Portal Quick Quote Completed
          operator: "equal",
          value: true,
        },
        {
          fact: "milestoneCompleted",
          params: { id: "100225" }, // Portal Full Quote Completed
          operator: "equal",
          value: true,
        },
        {
          fact: "milestoneCompleted",
          params: { id: "100013" }, // Core - Quotes Sent
          operator: "equal",
          value: true,
        },
      ],
    },
    estimatedDurationMinutes: 1,
  },

  "annuity-quotes-full": {
    toolId: "annuity-quotes-full",
    name: "Full Quotes",
    icon: "card-list",
    heading: "Adding details can increase your annuity income.",
    description:
      "Add your medical and lifestyle details to get a quote tailored to you. Including these additional details can significantly increase the quote you might receive, making it a worthwhile step.",
    route: "/fullquotepartial",
    routeRules: [
      {
        conditions: {
          any: [
            {
              fact: "milestoneCompleted",
              params: { id: "100225" },
              operator: "equal",
              value: true,
            },
            {
              fact: "milestoneCompleted",
              params: { id: "100013" },
              operator: "equal",
              value: true,
            },
          ],
        },
        route: "/fullquote",
      },
    ],
    completedWhen: {
      any: [
        {
          fact: "milestoneCompleted",
          params: { id: "100225" }, // Portal Full Quote Completed
          operator: "equal",
          value: true,
        },
        {
          fact: "milestoneCompleted",
          params: { id: "100013" }, // Core - Quotes Sent
          operator: "equal",
          value: true,
        },
      ],
    },
    estimatedDurationMinutes: 10,
  },

  "ifa-call-booking": {
    toolId: "ifa-call-booking",
    name: "Book an Appointment",
    icon: "calendar-check",
    heading: "Free, no obligation call with a pension specialist",
    description:
      "Speak with a qualified pension specialist for a free consultation. We'll take the time to understand your situation and provide clear guidance on the best way to make the most of your pension savings. You may even be eligible for better rates than those shown online, especially enhanced terms. No pressure, no obligation, just expert support tailored to you.",
    route: "/bookifacall",
    completedWhen: {
      any: [
        {
          fact: "milestoneCompleted",
          params: { id: "100227" }, // Portal IFA Appointment Booked
          operator: "equal",
          value: true,
        },
        {
          fact: "milestoneCompleted",
          params: { id: "100213" }, // IFA Call Booked
          operator: "equal",
          value: true,
        },
        {
          fact: "milestoneCompleted",
          params: { id: "100229" }, // Portal General Appointment Booked
          operator: "equal",
          value: true,
        },
      ],
    },
    estimatedDurationMinutes: 1,
  },

  // // original ifa call booking tool - bring back when retirement specialist tool is added
  //   "ifa-call-booking": {
  //   toolId: "ifa-call-booking",
  //   name: "Book an IFA Call",
  //   icon: "calendar-check",
  //   heading: "Free, no obligation advice call",
  //   description:
  //     "Speak with a qualified pension expert for a free consultation. Well take the time to understand your situation and provide a personalised recommendation on the best way to make the most of your pension savings. You may even be eligible for better rates than those shown online especially enhanced terms. No pressure, no obligation, just clear, expert guidance tailored to you.",
  //   route: "/bookifacall",
  //   completedWhen: {
  //     any: [
  //       {
  //         fact: "milestoneCompleted",
  //         params: { id: "100227" }, // Portal IFA Appointment Booked
  //         operator: "equal",
  //         value: true,
  //       },
  //       {
  //         fact: "milestoneCompleted",
  //         params: { id: "100213" }, // IFA Call Booked
  //         operator: "equal",
  //         value: true,
  //       },
  //     ],
  //   },
  //   estimatedDurationMinutes: 1,
  // },

  "fact-find": {
    toolId: "fact-find",
    name: "Fact Find",
    icon: "person-add",
    heading: "Complete a Fact Find before your advice call",
    description:
      "Complete a Fact Find. This can be done either by speaking with one of our specialists or by yourself, online and in your own time. Once the Fact Find is completed, you'll be all for your appointment with an Independent Financial Adviser.",
    route: "/factfind",
    completedWhen: {
      any: [
        {
          fact: "milestoneCompleted",
          params: { id: "100226" }, // Portal Fact Find Completed
          operator: "equal",
          value: true,
        },
        {
          fact: "milestoneCompleted",
          params: { id: "100026" }, // Core Fact Find Completed
          operator: "equal",
          value: true,
        },
      ],
    },
    estimatedDurationMinutes: 15,
  },

  "application": {
    toolId: "application",
    name: "Application",
    icon: "file-earmark-check",
    heading:
      "You're all set, nothing more to do on your end. Next step is to attend the scheduled advice call. Upon receiving your advice and recommendation, we'll send out an application form for you to sign and return. We'll handle all the heavy lifting, facilitating the transfer of your pension funds into your new retirement product. When your application is proceeding you can view and manage it here",
    description:
      "Upon receiving your advice and recommendation, we'll send out an application form for you to sign and return. We'll handle all the heavy lifting, facilitating the transfer of your pension funds into your new retirement product.",
    route: "/myapplication",
    completedWhen: {
      all: [
        {
          fact: "milestoneCompleted",
          params: { id: "100197" }, // Sale agreed to proceed
          operator: "equal",
          value: true,
        },
      ],
    },
    estimatedDurationMinutes: 15,
  },

  "loa-pension-review": {
    toolId: "loa-pension-review",
    name: "LOA for Pension Review",
    icon: "pencil-square",
    heading: "Submit a Letter of Authority (LOA) for free pension review",
    description:
      "Submit Letter of Authority to allow a free review of your pensions for hidden costs and fees",
    route: "/pensionreview",
    completedWhen: {
      any: [
        {
          fact: "milestoneCompleted",
          params: { id: "100233" }, // Annuity - LOA Received From Client
          operator: "equal",
          value: true,
        },
        {
          fact: "hasPensions",
          operator: "equal",
          value: true,
        },
      ],
    },
    estimatedDurationMinutes: 2,
  },
  "annual-review-summary": {
    toolId: "annual-review-summary",
    name: "Annual Review",
    icon: "fas fa-calendar-check",
    heading: "Annual Review",
    description: "Your completed annual review.",
    route: "/overview",
    completedWhen: {
      any: [
        {
          fact: "milestoneCompleted",
          params: { id: "100019" }, // Annual review complete
          operator: "equal",
          value: true,
        },
        {
          fact: "milestoneCompleted",
          params: { id: "100300" }, // Annual review cancelled (not proceeding outcome)
          operator: "equal",
          value: true,
        },
      ],
    },
    estimatedDurationMinutes: 0,
  },
  "annual-review-details": {
    toolId: "annual-review-details",
    name: "Your Details",
    icon: "person-add",
    heading: "Review and update your details",
    description:
      "Review and update your details for your annual review. If your circumstances have not changed, please check the information and complete the form.",
    route: "/my-details",
    completedWhen: {
      any: [
        {
          fact: "annualReviewMilestoneCompleted",
          params: { id: "100308" }, // Portal annual review details updated
          operator: "equal",
          value: true,
        },
      ],
    },
    estimatedDurationMinutes: 15,
  },
  "annual-review-booking": {
    toolId: "annual-review-booking",
    name: "Book Annual Review Appointment",
    icon: "calendar-check",
    heading: "Book your annual review appointment with a financial adviser",
    description:
      "Choose a convenient time for your annual review. During this appointment, your adviser will discuss your current circumstances, income needs, and any changes you may want to make.",
    route: "/annual-review-booking",
    completedWhen: {
      any: [
        {
          fact: "annualReviewMilestoneCompleted",
          params: { id: "100310" }, // Annual review booked
          operator: "equal",
          value: true,
        },
        {
          fact: "annualReviewMilestoneCompleted",
          params: { id: "100309" }, // Portal Annual review booked
          operator: "equal",
          value: true,
        },
      ],
    },
    estimatedDurationMinutes: 5,
  },
  "annual-review": {
    toolId: "annual-review",
    name: "Annual Review",
    icon: "file-earmark-check",
    heading: "Attend your annual review appointment at the scheduled time, don't forget to complete your Attitude to Risk questionnaire sent to your email",
    description:
      "Your adviser will discuss your current circumstances, income needs, and whether your plan still meets your objectives. After the meeting, we will confirm any recommendations and let you know if anything further is needed. Please remember to complete the attitude to risk form before the appointment that we sent to you by email.",
    route: "/myapplication",
    completedWhen: {
      any: [
        {
          fact: "annualReviewMilestoneCompleted",
          params: { id: "100019" }, // Annual review complete
          operator: "equal",
          value: true,
        },
        {
          fact: "annualReviewMilestoneCompleted",
          params: { id: "100300" }, // Annual review cancelled (not proceeding outcome)
          operator: "equal",
          value: true,
        },
      ],
    },
    estimatedDurationMinutes: 15,
  },
};
